import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import RecipeLineItemNumber from "./RecipeLineItemNumber";

/** Renderer for RecipeLineItem's "% of Total" (C8-37600) */
const PctOfTotal = declare(RecipeLineItemNumber, {
	/** boolean: true if the Heading to render is for "After Moisture Loss" */
	afterH2OLoss: false,

	/**
	 * @override
	 * Render RecipeLineItem's "% of Total" (C8-36029, C8-36606)
	 */
	toValue(ctx: Context, h: Heading) {
		const value = this.getPercentOfTotal(ctx, this.afterH2OLoss);
		return this.formatValue(value, this._getFormat(ctx, h));
	},

});

export = PctOfTotal;